// removed by extract-text-webpack-plugin
module.exports = {"twoColumns":"finance_analysts-panel_twoColumns","upgradesDowngrades":"finance_analysts-panel_upgradesDowngrades","upOrDown":"finance_analysts-panel_upOrDown","upgrade":"finance_analysts-panel_upgrade","downgrade":"finance_analysts-panel_downgrade","priceTargets":"finance_analysts-panel_priceTargets","header":"finance_analysts-panel_header","barChart":"finance_analysts-panel_barChart","dashedLine":"finance_analysts-panel_dashedLine","noData":"finance_analysts-panel_noData","verticalBar":"finance_analysts-panel_verticalBar"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/components/analysts-panel/style.less
// module id = 504
// module chunks = 0